export default {
  namespaced: true,
  state: {
    items: [],
    types: [
      {
        value: "mailing",
        text: "Emails"
      },
      {
        value: "shipping",
        text: "Expédition"
      },
    ]
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type),
    getSetting: state => setting => state.items.find(item => item.setting == setting)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'myaxilocsetting',
        api_data_path: 'myaxilocSettings',
        namespace: 'myaxiloc_setting'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'myaxilocsetting',
        namespace: 'myaxiloc_setting',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'myaxilocsetting',
        namespace: 'myaxiloc_setting',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'myaxilocsetting',
        namespace: 'myaxiloc_setting',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'myaxilocsetting',
        namespace: 'myaxiloc_setting',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/myaxiloc_setting.js